import { NimmstaLayout } from './NimmstaLayout';
const LAYOUT = `<?xml version="1.0" encoding="utf-8"?>
<NimmstaLayout name="One Cell Layout with Header">
    <device width="1.54" height="1.54" pxx="200" pxy="200">
        <screen default="true" name="default">
            <staticElements>
                <statusbar />
                <cell x="3" horizontalAlignment="center" fontSize="17pt" name="header"></cell>
                <horizontalLine y="50"></horizontalLine>
                <cell x="3" horizontalAlignment="center" fontSize="26pt" wrapMode="wrap" maxLines="0" name="text"></cell>
            </staticElements>
        </screen>
    </device>
</NimmstaLayout>`;
export class OneCellHeaderLayout extends NimmstaLayout {
    constructor(header, text) {
        super(LAYOUT, { header, text });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT25lQ2VsbEhlYWRlckxheW91dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWxzL2xheW91dHMvT25lQ2VsbEhlYWRlckxheW91dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFFaEQsTUFBTSxNQUFNLEdBQUc7Ozs7Ozs7Ozs7OztpQkFZRSxDQUFDO0FBS2xCLE1BQU0sT0FBTyxtQkFBb0IsU0FBUSxhQUFhO0lBQ3BELFlBQVksTUFBYyxFQUFFLElBQVk7UUFDdEMsS0FBSyxDQUFDLE1BQU0sRUFBRSxFQUFFLE1BQU0sRUFBRSxJQUFJLEVBQUUsQ0FBQyxDQUFDO0lBQ2xDLENBQUM7Q0FDRiJ9